import { type APPLICANT_ATTRIBUTION_BOTH_TYPE, LOAN_REQUEST_COMMANDS } from 'cpool-constants';

import { IMMOBILIENDARLEHEN } from '../../../types';
import { InstallmentLoanFields } from '../shared/InstallmentLoanFields';

type Props = {
    index: number;
    applicant: APPLICANT_ATTRIBUTION_BOTH_TYPE;
};

export const LoanForm: React.FC<Props> = ({ applicant, index }) => (
    <InstallmentLoanFields
        type={IMMOBILIENDARLEHEN}
        index={index}
        applicant={applicant}
        commandName={LOAN_REQUEST_COMMANDS.changeLiabilityRealEstateLoan}
    />
);
